import { observer } from 'mobx-react';
import { useStore } from '../../core/utils/hook';
import { useForm } from 'react-hook-form';
import yup from '../../core/utils/yupValidate';
import { yupResolver } from '@hookform/resolvers/yup';

const ChangeEmail = observer(({ setStep, emailCurrent }) => {
  
    const validateChangeEmailSchema = yup.object().shape({
        newEmail: yup
            .string()
            .email('メールアドレスの形式が正しくありません。') // Check email format
            .required('新しいメールアドレスを入力する必要があります。'),
        confirmEmail: yup
            .string()
            .required('新しいメールアドレス確認を入力する必要があります。')
            .oneOf([yup.ref('newEmail')], '新しいメールアドレスと新しいメールアドレス確認が一致しません。')
    });

    
    const { authStore: { changeEmail } } = useStore();
    
    const { 
        register, 
        handleSubmit, 
        trigger, 
        formState: { errors, isSubmitting } 
    } = useForm({
        resolver: yupResolver(validateChangeEmailSchema),
        mode: 'onChange'
    });

    // 3. Handle Submit
    const handleSubmitChangeEmail = async (data) => {
        try {
            const res = await changeEmail({
                newEmail: data.newEmail
            });
            if (res?.ok) {
                setStep(1);
            }
        } catch (error) {
            console.error('Failed to update email:', error);
        }
    };

    return (
        <div>
            <div className='content-signin'>
                <div className='container'>
                    <div className='content-form'>
                        <h2 className='title-primary'>メールアドレス更新</h2>
                        
                        <form onSubmit={handleSubmit(handleSubmitChangeEmail)}>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                fontWeight: 'normal',
                                color: '#000',
                                fontSize: '17px',
                                marginBottom: '20px'
                            }}>
                                <span>新しいメールアドレスを入力してください。</span>
                                <span>本メールアドレスは、今後ログイン時のIDとして使用されます。</span>
                            </div>

                            {/* New Email field */}
                            <div className='item item-1'>
                                <label htmlFor='newEmail'>新しいメールアドレス<span>*</span></label>
                                <input 
                                    type='text' 
                                    {...register('newEmail', {
                                        // When the user edits this field, re-trigger validation on the confirm field
                                        onChange: () => { 
                                            trigger('confirmEmail'); 
                                        }
                                    })}
                                />
                                {errors?.newEmail && (
                                    <div className='text-danger mg-t-5'>{errors.newEmail?.message}</div>
                                )}
                            </div>

                            {/* Confirm Email field */}
                            <div className='item'>
                                <label htmlFor='confirmEmail'>新しいメールアドレス確認 <span>*</span></label>
                                <div className='input'>
                                    <input 
                                        type='text' 
                                        {...register('confirmEmail')} 
                                    />
                                </div>
                                {errors?.confirmEmail && (
                                    <div className='text-danger mg-t-5'>{errors.confirmEmail?.message}</div>
                                )}
                            </div>

                            <div className='container-change-email-button'>
                                <button 
                                    type='button' 
                                    onClick={() => setStep(1)}
                                    disabled={isSubmitting}
                                    className='container-change-email-button-cancel'
                                >
                                    ログアウト
                                </button>
                                
                                <button 
                                    type='submit' 
                                    className='container-change-email-button-confirm'
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? '処理 trung...' : '更新'}
                                </button>
                            </div>       
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default ChangeEmail;